import React from 'react';
import {
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonIcon,
    IonText,
    IonPopover
} from '@ionic/react';
import { informationCircle } from 'ionicons/icons';
import { colorTheme } from '../../utils/constants';
import { Card } from '@tremor/react';

function formatDate(date) {
    if (!date) return "N/A";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
}

export default function SMSBalance({ smsAmount = 0, lastSmsPaymentDate = null, currency = "", onClick }) {
    return (
        <Card className="mb-3 mt-5" style={{ height: "fit-content", borderRadius: "10px" }}>
            <IonCardHeader>
                <IonCardTitle className="text-center">
                    SMS Balance
                </IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
                <IonGrid>
                    <IonRow className='mt-2' style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
                        <IonCol className='mt-2'>
                            <IonText>
                                <h5>Balance ({currency}) <IonIcon id="smsBalanceInfo" icon={informationCircle} className="ml-2" /></h5>
                                <IonPopover trigger="smsBalanceInfo">
                                    <IonText>This is the amount of your current SMS balance.</IonText>
                                </IonPopover>
                                <IonText color="primary" style={{ fontSize: '1.5em' }}>
                                    {smsAmount.toLocaleString("en-US")}
                                </IonText>
                            </IonText>
                        </IonCol>
                        <IonCol className='mt-2'>
                            <IonText>
                                <h5>Last Purchase <IonIcon id="lastSmsPaymentInfo" icon={informationCircle} className="ml-2" /></h5>
                                <IonPopover trigger="lastSmsPaymentInfo">
                                    <IonText>This is the date of your last SMS purchase.</IonText>
                                </IonPopover>
                                <IonText color="primary" style={{ fontSize: '1.5em' }}>
                                    {lastSmsPaymentDate ? formatDate(lastSmsPaymentDate) : 'N/A'}
                                </IonText>
                            </IonText>
                        </IonCol>
                        <IonButton
                            className='mt-2 mr-2'
                            fill='outline'
                            onClick={onClick}
                            style={{
                                borderRadius: "10px",
                                height: "fit-content"
                            }}
                        >
                            Buy SMS
                        </IonButton>
                    </IonRow>
                </IonGrid>
            </IonCardContent>
        </Card>
    );
}
